import { Badge, Box, Button, IconButton } from "@mui/material";
import { keyframes } from "@emotion/react";
import Notification from "iconsax-reactjs/dist/esm/Notification.js";
import Message from "iconsax-reactjs/dist/esm/Message.js";
import ArrowLeft2 from "iconsax-reactjs/dist/esm/ArrowLeft2.js";
import ProfileMenu from "../ProfileMenu";
import { useDispatch, useSelector } from "react-redux";
import { openAuthModal } from "../../../../store/Slice/reducers";
import { useGetChatsQuery } from "../../../../store/Slice/rtk";
import { useNavigate } from "react-router-dom";

const pulseOrange = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(255,107,53,0.5); }
  70% { box-shadow: 0 0 0 6px rgba(255,107,53,0); }
  100% { box-shadow: 0 0 0 0 rgba(255,107,53,0); }
`;

const pulseRed = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(211,47,47,0.5); }
  70% { box-shadow: 0 0 0 6px rgba(211,47,47,0); }
  100% { box-shadow: 0 0 0 0 rgba(211,47,47,0); }
`;

const iconButtonSx = {
  bgcolor: "#fff",
  border: "1px solid",
  borderColor: "divider",
  width: 48,
  height: 48,
};

function badgeSx(pulseKeyframe, hasUnread) {
  return {
    "& .MuiBadge-badge": {
      top: -6,
      right: -6,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      animation: hasUnread ? `${pulseKeyframe} 2s ease-out infinite` : "none",
    },
  };
}

export default function NavActions({
  isAuthenticated,
  fullname,
  profileImage,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { unreadCount } = useSelector((state) => state.notifications);
  const role = useSelector((state) => state.userSlice.role);

  // مجموع پیام‌های خونده‌نشده‌ی همه‌ی چت‌ها — فقط برای کاربر لاگین‌کرده واکشی می‌شه
  const { data: chatsData } = useGetChatsQuery(undefined, {
    skip: !isAuthenticated,
  });
  const unreadMessages =
    chatsData?.data?.filter((chat) => {
      const uc = chat?.unreadCount;
      const mine = typeof uc === "number" ? uc : uc?.[role] || 0;
      return mine > 0;
    }).length || 0;

  const MessageButton = (
    <IconButton
      sx={{
        ...iconButtonSx,
        transition: "transform .15s ease",
        "&:hover": { transform: "translateY(-2px)" },
      }}
      onClick={() => {
        navigate("profile/chats");
      }}
      aria-label="پیام‌ها"
    >
      <Badge
        badgeContent={unreadMessages > 0 ? unreadMessages : 0}
        color="error"
        max={99}
        invisible={unreadMessages === 0}
        sx={badgeSx(pulseRed, unreadMessages > 0)}
      >
        <Message size={18} variant="Outline" />
      </Badge>
    </IconButton>
  );

  const NotificationButton = (
    <IconButton
      sx={{
        ...iconButtonSx,
        transition: "transform .15s ease",
        "&:hover": { transform: "translateY(-2px)" },
      }}
      onClick={() => {
        navigate("profile");
      }}
      aria-label="اعلان‌ها"
    >
      <Badge
        badgeContent={unreadCount > 0 ? unreadCount : 0}
        color="secondary"
        max={99}
        invisible={unreadCount === 0}
        sx={badgeSx(pulseOrange, unreadCount > 0)}
      >
        <Notification size={18} variant="Outline" />
      </Badge>
    </IconButton>
  );

  if (isAuthenticated) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        {MessageButton}
        {NotificationButton}

        <ProfileMenu
          name={fullname?.length > 15 ? fullname.slice(0, 13) + ".." : fullname}
          profileImage={profileImage}
          initials={fullname?.at(0)}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      {/* <Button color="inherit" sx={{ color: "primary.main", fontWeight: 600 }}>
        ورود
      </Button> */}
      <Button
        variant="contained"
        color="secondary"
        sx={{
          borderRadius: 999,
          px: 2.5,
          boxShadow: "0 8px 20px -8px rgba(255,107,53,.55)",
          transition: "transform .15s ease",
          "&:hover": { transform: "translateY(-2px)" },
          "&:active": { transform: "scale(0.97)" },
        }}
        onClick={() => {
          dispatch(openAuthModal("login"));
        }}
      >
        ورود به حساب کاربری
      </Button>
    </Box>
  );
}
